import React from 'react';

function BlockUserIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 16 16"
    >
      <path
        fill="#0E0E11"
        d="M6.2236328,7.3600979c2.0263672,0,3.6757812-1.651329,3.6757812-3.6800489S8.25,0,6.2236328,0S2.5488281,1.651329,2.5488281,3.6800489S4.1972656,7.3600979,6.2236328,7.3600979z M6.2236328,1.001161c1.4755859,0,2.6757812,1.2015887,2.6757812,2.6788878S7.6992188,6.3589368,6.2236328,6.3589368c-1.4746094,0-2.6748047-1.2015886-2.6748047-2.6788878S4.7490234,1.001161,6.2236328,1.001161z"
      />
      <path
        fill="#0E0E11"
        d="M11.5,6.9895511c-1.1851807,0-2.2568359,0.4700885-3.0612793,1.2224259c-0.513916-0.1643753-1.0441895-0.2633061-1.5871582-0.2633061H5.2636719C2.3613281,7.9486709,0,10.3127403,0,13.2184544V16h1v-2.7815456C1,10.865139,2.9130859,8.949832,5.2636719,8.949832h1.5878906c0.2978516,0,0.5898438,0.0403299,0.8778076,0.1016808C7.2719727,9.7566147,7,10.5931559,7,11.4947758C7,13.9791021,9.0185547,16,11.5,16s4.5-2.0208979,4.5-4.5052242S13.9814453,6.9895511,11.5,6.9895511z M11.5,14.9988394c-1.9296875,0-3.5-1.5721359-3.5-3.5040636s1.5703125-3.5040641,3.5-3.5040641S15,9.5628471,15,11.4947758S13.4296875,14.9988394,11.5,14.9988394z"
      />
      <path
        fill="#0E0E11"
        d="M13.0380859,11.0362358H9.9628906c-0.2763672,0-0.5,0.2238922-0.5,0.5005808c0,0.2766876,0.2236328,0.5005798,0.5,0.5005798h3.0751953c0.2763672,0,0.5-0.2238922,0.5-0.5005798C13.5380859,11.260128,13.3144531,11.0362358,13.0380859,11.0362358z"
      />
    </svg>
  );
}

export default BlockUserIcon;
